<div class="px-6 py-4 working-hours-card">
  <p-toast></p-toast>
  <p-confirmDialog />

  <div class="flex justify-content-between align-items-center mb-4">
    <p class="text-xl font-semibold">{{ 'worklog.title' | translate }}</p>

    <div class="flex gap-2 align-items-center">
      <p-dropdown
        [options]="years"
        [(ngModel)]="selectedYear"
        (onChange)="onYearChange()"
        optionLabel="label"
        optionValue="value"
        styleClass="w-8rem">
      </p-dropdown>

      <button
        pButton
        *emPermission="Permission.CONFIGURATION_WRITE"
        type="button"
        icon="pi pi-plus"
        class="p-button-success"
        (click)="openAddDialog()"></button>
    </div>
  </div>
  <p-table
    #dt
    [value]="worklogRows"
    responsiveLayout="scroll"
    [paginator]="true"
    [rows]="10"
    styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'worklog.group' | translate }}</th>
        <th>{{ 'worklog.period' | translate }}</th>
        <th>{{ 'worklog.hoursPerWeek' | translate }}</th>
        <th>{{ 'worklog.startDate' | translate }}</th>
        <th>{{ 'worklog.endDate' | translate }}</th>
        <th style="width: 180px">{{ 'worklog.actions' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.group.groupName }}</td>
        <td>{{ row.period.type }}</td>
        <td>{{ row.period.hoursPerWeek }}</td>
        <td>{{ row.period.startDate | date: 'dd/MM/yyyy' }}</td>
        <td>{{ row.period.endDate | date: 'dd/MM/yyyy' }}</td>

        <td class="flex gap-2">
          <button
            pButton
            icon="pi pi-pencil"
            class="p-button-text p-button-sm"
            *emPermission="Permission.CONFIGURATION_WRITE"
            (click)="editPeriod(row.group, row.period)"></button>

          <button
            pButton
            icon="pi pi-trash"
            class="p-button-text p-button-danger p-button-sm"
            *emPermission="Permission.CONFIGURATION_WRITE"
            (click)="deletePeriod(row.period.id, row.group)"></button>

          <button
            pButton
            icon="pi pi-sitemap"
            class="p-button-text p-button-help p-button-sm"
            *emPermission="[Permission.CONFIGURATION_READ, Permission.CONFIGURATION_WRITE]"
            (click)="openSchedule(row.period, row.group)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="table-actions" *emPermission="Permission.CONFIGURATION_WRITE">
    <button
      pButton
      type="button"
      [label]="'common.cancel' | translate"
      class="p-button-text"
      [disabled]="!hasPendingChanges || isSavingPendingChanges"
      (click)="cancelPendingChanges()"></button>

    <button
      pButton
      type="button"
      [label]="'common.save' | translate"
      class="p-button-success"
      [loading]="isSavingPendingChanges"
      [disabled]="!hasPendingChanges || isSavingPendingChanges"
      (click)="savePendingChanges()"></button>
  </div>
</div>

<p-dialog
  [header]="'worklog.groupDialogTitle' | translate"
  [(visible)]="displayDialog"
  (onHide)="onAddGroupDialogHide()"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false">
  <div class="p-fluid">
    <div class="field">
      <label>{{ 'worklog.groupName' | translate }}</label>
      <input pInputText [(ngModel)]="newGroup.groupName" (ngModelChange)="onAddGroupFieldChange()" />
    </div>

    <div class="field">
      <label>{{ 'worklog.numberOfPeriods' | translate }}</label>
      <p-dropdown
        [options]="[
          { label: 'worklog.periodCount1' | translate, value: 1 },
          { label: 'worklog.periodCount2' | translate, value: 2 },
          { label: 'worklog.periodCount3' | translate, value: 3 },
        ]"
        [(ngModel)]="newGroup.numberOfPeriods"
        (ngModelChange)="onAddGroupFieldChange()">
      </p-dropdown>
    </div>

    <div class="field" *ngIf="newGroup.numberOfPeriods >= 1">
      <label>{{ 'worklog.period1Hours' | translate }}</label>
      <p-inputNumber
        [(ngModel)]="normalHours"
        mode="decimal"
        [min]="0"
        [max]="60"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        (ngModelChange)="onAddGroupFieldChange()">
      </p-inputNumber>
    </div>

    <div class="field" *ngIf="newGroup.numberOfPeriods >= 2">
      <label>{{ 'worklog.period2Hours' | translate }}</label>
      <p-inputNumber
        [(ngModel)]="summerHours"
        mode="decimal"
        [min]="0"
        [max]="60"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        (ngModelChange)="onAddGroupFieldChange()">
      </p-inputNumber>
    </div>

    <div class="field" *ngIf="newGroup.numberOfPeriods === 3">
      <label>{{ 'worklog.period3Hours' | translate }}</label>
      <p-inputNumber
        [(ngModel)]="ramadanHours"
        mode="decimal"
        [min]="0"
        [max]="60"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        (ngModelChange)="onAddGroupFieldChange()">
      </p-inputNumber>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="'common.cancel' | translate" class="p-button-text" (click)="cancelAddGroup()"></button>

    <button pButton [label]="'common.save' | translate" class="p-button-success" (click)="saveGroup()"></button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="'worklog.periodDialogTitle' | translate"
  [(visible)]="displayPeriodDialog"
  (onHide)="onPeriodDialogHide()"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '400px' }"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ overflow: 'visible' }"
  styleClass="working-period-dialog">
  <div class="p-fluid">
    <div class="field">
      <label>{{ 'worklog.type' | translate }}</label>
      <input pInputText [(ngModel)]="newPeriod.type" disabled />
    </div>

    <div class="field">
      <label>{{ 'worklog.hoursPerWeek' | translate }}</label>
      <p-inputNumber
        [(ngModel)]="newPeriod.hoursPerWeek"
        mode="decimal"
        [min]="0"
        [max]="60"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        (ngModelChange)="onPeriodFieldChange()">
      </p-inputNumber>
    </div>

    <div class="field">
      <label>{{ 'worklog.startDate' | translate }}</label>
      <p-calendar
        [(ngModel)]="newPeriod.startDate"
        [disabled]="isEditingFirstPeriod"
        [minDate]="periodMinDate"
        [maxDate]="periodMaxDate"
        [appendTo]="'body'"
        [baseZIndex]="11000"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        (ngModelChange)="onPeriodFieldChange()">
      </p-calendar>
    </div>

    <div class="field">
      <label>{{ 'worklog.endDate' | translate }}</label>
      <p-calendar
        [(ngModel)]="newPeriod.endDate"
        [disabled]="isEditingLastPeriod"
        [minDate]="periodMinDate"
        [maxDate]="periodMaxDate"
        [appendTo]="'body'"
        [baseZIndex]="11000"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        (ngModelChange)="onPeriodFieldChange()">
      </p-calendar>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="'common.cancel' | translate" class="p-button-text" (click)="cancelEditPeriod()"></button>

    <button pButton [label]="'common.save' | translate" class="p-button-success" (click)="updatePeriod()"></button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="'worklog.reassignDialogTitle' | translate"
  [(visible)]="displayGroupReassignDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="false"
  [style]="{ width: '560px' }"
  styleClass="reassign-group-dialog"
  (onHide)="cancelGroupReassignment()">
  <div class="reassign-dialog-body">
    <p class="reassign-lead mb-3">
      {{ 'worklog.reassignDialogMessage' | translate: { group: groupPendingDeletionName } }}
    </p>

    <div class="reassign-mode-switch mb-3">
      <button
        type="button"
        class="mode-chip"
        [class.active]="reassignMode === 'existing'"
        (click)="reassignMode = 'existing'">
        {{ 'worklog.reassignModeExisting' | translate }}
      </button>

      <button
        type="button"
        class="mode-chip"
        [class.active]="reassignMode === 'create'"
        (click)="reassignMode = 'create'">
        {{ 'worklog.reassignModeCreate' | translate }}
      </button>
    </div>

    <div class="field" *ngIf="reassignMode === 'existing'">
      <label class="field-label">{{ 'worklog.reassignTargetLabel' | translate }}</label>
      <p-dropdown
        [options]="reassignTargetOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="reassignTargetGroupId"
        [showClear]="true"
        [appendTo]="'body'"
        styleClass="w-full">
      </p-dropdown>
      <small class="field-help" *ngIf="!reassignTargetOptions.length">
        {{ 'worklog.reassignNoTargetAvailable' | translate }}
      </small>
    </div>

    <div class="field" *ngIf="reassignMode === 'create'">
      <label class="field-label">{{ 'worklog.reassignNewGroupLabel' | translate }}</label>
      <input
        pInputText
        [(ngModel)]="newReassignGroupName"
        [placeholder]="'worklog.reassignNewGroupPlaceholder' | translate"
        maxlength="60"
        class="w-full" />
      <small class="field-help">
        {{ 'worklog.reassignNewGroupHelp' | translate }}
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      [label]="'common.cancel' | translate"
      class="p-button-text"
      (click)="cancelGroupReassignment()"></button>

    <button
      pButton
      [label]="'common.save' | translate"
      class="p-button-success"
      [loading]="isCreatingReassignGroup"
      [disabled]="isCreatingReassignGroup"
      (click)="confirmGroupReassignment()"></button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="'worklog.dailyHours' | translate"
  [(visible)]="displayScheduleDialog"
  (onHide)="onScheduleDialogHide()"
  [modal]="true"
  [style]="{ width: '1200px' }"
  [contentStyle]="{ 'max-height': '85vh', overflow: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [position]="'center'">
  <div class="schedule-container">
    <div class="schedule-main">
      <div class="schedule-top">
        <div class="total-week">
          {{ 'worklog.totalWeek' | translate }}
          <span>{{ totalWeekHours | number: '1.0-1' }} h</span>
        </div>

        <div class="selectors">
          <p-dropdown
            [options]="groupOptions"
            [(ngModel)]="selectedGroupId"
            [placeholder]="'worklog.group' | translate"
            (onChange)="onGroupChange()">
          </p-dropdown>

          <p-dropdown
            [options]="periodOptions"
            [(ngModel)]="selectedPeriodId"
            [placeholder]="'worklog.period' | translate"
            (onChange)="onPeriodChange()">
          </p-dropdown>
        </div>
      </div>

      <p-table [value]="dailySchedule" styleClass="p-datatable-sm schedule-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 120px">{{ 'worklog.day' | translate }}</th>
            <th style="width: 90px">{{ 'worklog.hours' | translate }}</th>
            <th style="width: 110px">{{ 'worklog.start' | translate }}</th>
            <th style="width: 110px">{{ 'worklog.end' | translate }}</th>
            <th style="width: 100px">{{ 'worklog.break' | translate }}</th>
            <th>{{ 'worklog.notes' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-day>
          <tr>
            <td class="day-name">{{ day.day }}</td>

            <td>
              <p-inputNumber
                [(ngModel)]="day.workingHours"
                (ngModelChange)="onHoursChange(day)"
                [min]="0"
                [step]="0.5"
                [max]="24"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="1"
                inputStyleClass="small-input"
                [disabled]="!canWrite">
              </p-inputNumber>
            </td>

            <td>
              <input
                pInputText
                [(ngModel)]="day.startTime"
                [disabled]="!canWrite || day.workingHours === 0"
                (ngModelChange)="onStartTimeChange(day)"
                class="small-input" />
            </td>

            <td>
              <input pInputText [(ngModel)]="day.endTime" (ngModelChange)="onEndTimeChange(day)" class="small-input" />
            </td>

            <td>
              <p-inputNumber
                [(ngModel)]="day.breakDuration"
                (ngModelChange)="onBreakChange(day)"
                mode="decimal"
                suffix=" h"
                [min]="0"
                [minFractionDigits]="0"
                [maxFractionDigits]="2">
              </p-inputNumber>
            </td>

            <td>
              <input
                pInputText
                [(ngModel)]="day.notes"
                (ngModelChange)="onHoursChange(day)"
                class="small-input"
                [disabled]="!canWrite" />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="schedule-summary">
      <div class="summary-card improved">
        <div class="summary-header">
          {{ 'worklog.yearPartitions' | translate }}
        </div>

        <table class="summary-table improved-table">
          <thead>
            <tr>
              <th style="width: 30%">{{ 'worklog.startDate' | translate }}</th>
              <th style="width: 30%">{{ 'worklog.endDate' | translate }}</th>
              <th style="width: 40%">{{ 'worklog.partialDistribution' | translate }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let p of yearPartitions">
              <td>{{ p.startDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ p.endDate | date: 'dd/MM/yyyy' }}</td>
              <td class="partial">{{ p.partial }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="'common.cancel' | translate" class="p-button-text" (click)="cancelSchedule()"></button>

    <button
      pButton
      *emPermission="Permission.CONFIGURATION_WRITE"
      [label]="'common.save' | translate"
      class="p-button-success"
      (click)="saveSchedule()"></button>
  </ng-template>
</p-dialog>
